export default interface DeliveryLocation {
  //id: number
  codigo_cliente: number;
  domicilio: string;
  localidad: string;
  codigopostal: string;
  codigo_provincia: number;
  telefono: string;
  horariodeatencion: string;
  quienrecibe?: string;
  codigo_localidad: number;
  codigo_zonadereparto: number;
  principal: number;
  orden: number;
  zonasdereparto_descripcion?: string;
}

export const commonDeliveryLocation: DeliveryLocation =
{
  codigo_cliente: 0,
  domicilio: 'RETIRA EN PLANTA (sujeto a turno/disponibilidad)',
  localidad: '',
  codigopostal: '',
  codigo_provincia: 2,
  telefono: '',
  horariodeatencion: '',
  codigo_localidad: 0,
  codigo_zonadereparto: 0,
  principal: -99,
  orden: 0,
  zonasdereparto_descripcion: ''
}

export const commonChacoDeliveryLocation: DeliveryLocation =
{
  codigo_cliente: 0,
  domicilio: 'RETIRA EN DEPOSITO CHACO',
  localidad: '',
  codigopostal: '',
  codigo_provincia: 6,
  telefono: '',
  horariodeatencion: '',
  codigo_localidad: 0,
  codigo_zonadereparto: 0,
  principal: -99,
  orden: 0,
  zonasdereparto_descripcion: ''
}
